import { render } from "./typeList.vue?vue&type=template&id=7423d3b5"
import script from "./typeList.vue?vue&type=script&lang=js"
export * from "./typeList.vue?vue&type=script&lang=js"

import "./typeList.vue?vue&type=style&index=0&id=7423d3b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__